/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getSyncStatus.defs'
export { main as default } from './getSyncStatus.defs'
